import { render } from "./museumActivityPage.vue?vue&type=template&id=02bcfedb&scoped=true"
import script from "./museumActivityPage.vue?vue&type=script&lang=js"
export * from "./museumActivityPage.vue?vue&type=script&lang=js"

import "./museumActivityPage.vue?vue&type=style&index=0&id=02bcfedb&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bcfedb"]])

export default __exports__